import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: "eng",
};

export const sliceLanguage = createSlice({
  name: "home",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = sliceLanguage.actions;
export default sliceLanguage.reducer;
